import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginTop: 80,
    width: 350,
    justifyContent: "space-between",
    padding: 16,
    alignSelf: "center",
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    alignItems: "center",
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  tittleTrocarSenha: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#077A97",
    textTransform: "uppercase",
  },
});

export default styles;
